// src/Layouts/AuditorLayout.jsx

import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';

// FIXED paths — going into components/auditor/ from Layouts/
import AuditorSidebar from '../components/audit/AuditorSidebar';
import { useAuth }    from '../contexts/AuthContext';

const SIDEBAR_WIDTH_EXPANDED  = 260;
const SIDEBAR_WIDTH_COLLAPSED = 76;

const AuditorLayout = () => {
  const { logout }  = useAuth();
  const theme        = useTheme();
  const isMobile     = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  const currentWidth = isMobile
    ? 0
    : sidebarOpen
    ? SIDEBAR_WIDTH_EXPANDED
    : SIDEBAR_WIDTH_COLLAPSED;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AuditorSidebar
        logout={logout}
        isOpen={sidebarOpen}
        isMobile={isMobile}
        onSidebarToggle={setSidebarOpen}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${currentWidth}px)`,
          transition: 'width 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
          minHeight: '100vh',
          bgcolor: '#f8fafc',
          overflow: 'auto',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AuditorLayout;